const colors = {
  clickarisePurple:'#5B48B8'
}

export default colors;



// WEBPACK FOOTER //
// ./src/styleguide/colors.js